<template>
  <TemplateTable
    :title="$t('menu.recom-resales-stocks')"
    :text="$t('resalesStocks.description')"
    name="resalesStocks"
    :url="$listRoutes.recomResalesStock"
    :table="resalesStocks"
    :filters="resalesStocksFilters"
    :fields="fields"
    :display-date="true"
    :filtersWording="filtersWording"
  />
</template>

<script>
import TemplateTable from "@/components/templates/TemplateTable";
import { mapState } from "vuex";
import currencyRouteMixin from "@/mixins/currencyRouteMixin";

export default {
  name: "RecomResalesStocks",
  mixins: [currencyRouteMixin],
  components: { TemplateTable },
  data() {
    return {
        filtersWording: {
            declarer: {
                filterTitle: this.$t('recom_articles.declarer.title'),
                customer: this.$t('recom_articles.declarer.customer'),
                store: this.$t('recom_articles.declarer.store'),
                web: this.$t('recom_articles.declarer.store'),
                warehouse: this.$t('recom_articles.declarer.warehouse'),
            },
            channel: {
                filterTitle: this.$t('recom_articles.declarer.title'),
                customer: this.$t('recom_articles.declarer.customer'),
                web: this.$t('recom_articles.declarer.customer'),
                store: this.$t('recom_articles.declarer.store'),
                warehouse: this.$t('recom_articles.declarer.warehouse'),
            },
            reference: {
                filterTitle: this.$t('global.article_id')
            },
            customer: {
                filterTitle: this.$t('global.email')
            },
            dateControl: {
                filterTitle: this.$t('global.controlReviewCreatedAt')
            }
        },
      fields: [
        { key: "id", type: "eye", route: "recom_tradein-article", size: "xs" },
        { key: "brand", type: "client", size: "l" },
        { key: "reference", size: "l", translation: "global.article_id" },
        { key: "ean", size: "l" },
          { key: 'initialReview.condition', type: 'tagType', translation: "global.creditReviewCondition" },
          { key: 'controlReview.condition', type: 'tagType', size: 'm' },
          {
          key: "priceOffer",
          type: "formatPrice",
          size: "m",
          translationKey: "tradeinPrice",
        },
        {
          key: "amountCredited",
          type: "formatPrice",
          size: "lm",
          translationKey: "controlReviewPrice",
        },
        { key: "priceResale", type: "formatPrice", size: "m" },
        { key: "condition", size: "m", type: "tagType" },
        { key: "tradeInCart.channel", type: "tagType", size: 'l', translation: 'global.article_origin' },
        { key: "warehouseSlot", type: "boolean", translation: "global.stocked" },
        { key: "warehouseSlot", type: "copy", size: "m", translation: "global.warehouseSlotPosition" },
        { key: "warehouseStage", type: "tagType", size: "m" },
        { key: "createdAt", type: "date", size: "m" },
        { key: "updatedAt", type: "date", size: "m" },
        { key: "tradeInCart.customer.profile", type: "tagType", size: 'm' },
          { key: 'tradeInCart.customer.countryCode', translation: 'global.country', translationKey: "countries_code", type: 'country'}
      ],
    };
  },
  computed: {
    ...mapState(["resalesStocks", "resalesStocksFilters"]),
  },
};
</script>
